// pages/Login/LoginVerify2FA.tsx
import React from 'react';
import { Card, Col, Container, Row } from 'shared-portal-component';

import AuthCode from '@/components/organism/Login/AuthCode';
import { useAuth2FAVerify } from '@/hooks/auth/useAuth2FAVerify';
import AuthBodyText from '@/components/atomic/AuthBodyText/AuthBodyText';
import AuthHeaderText from '@/components/atomic/AuthHeaderText/AuthHeaderText';

/**
 * /login/2fa/verify route
 * Handles 2FA code verification
 */
const LoginVerify2FA: React.FC = () => {
  const { state, handlers } = useAuth2FAVerify();
  if(state.twoFactorMethod === undefined) {
    return <div>Error: No 2FA method selected.</div>;
  }
  const label =
    state.twoFactorMethod === 'sms'
      ? `We’ve sent a 6-digit code to your phone number ending in ${state.masked}.`
      : `We’ve sent a 6-digit code to your email address ${state.masked}.`;

return (
      <Container fluid>
      <Card>
        <Row spacing="md">
          <Col size={12}>
            <AuthHeaderText
              text="Your two-factor authentication code"

            />
            <AuthBodyText>
              {label} Please enter it below or, if you haven’t received it, click the Resend link.
            </AuthBodyText>
          </Col>
        </Row>
        <Row justify="center" spacing="none">
  <AuthCode
    onBack={() => {
      void handlers.back();
    }}
    onResend={() => {
      void handlers.resend();
    }}
    onSubmit={(code) => {
      void handlers.verify(code);
    }}
    loading={state.isLoading}
    error={state.error}
  />
        </Row>
      </Card>
    </Container>

);
};

export default LoginVerify2FA;
